/// <reference path='../_all.ts' />

module product {
  'use strict';

  export class ProductData {
    constructor(
      public Current: IRouteEntry,
      public Previous: IRouteEntry,
      public Next: IRouteEntry,
      public Product: ProductDetail,
      public ProductImageName: string,
      public ProductLegacyImagePath: string,
      public Features: Feature[],
      public Specifications: any,
      public DataSheet: library.Document,
      public ControlUnits : ControlUnit[]
      ) { }
  }

  export class ProductDetail {
    constructor(
      public Name: string,
      public Text: string,
      public LongDesc: string,
      public ProductLegacyImagePath: string,
      public IsObsolete: boolean,
      public KillingDate: Date
      ) { }
  }

  export class ControlUnit {
    constructor(
      public Id : string,
      public Name : string,
      public Text : string,
      public Url : string
      ) { }
  }
}